var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasPermission('dashboards.driver'))?_c('driver-dashboard'):_c('default-dashboard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }